/** Test features are latched at application load, as in ODMS. */
const isFeatureTestMode = (feature: string): boolean => {
    try {
        return new URLSearchParams(window.location.search).get(feature) === 'test';
    } catch {
        return false;
    }
};

// SPA navigation preserves this value; reloading without the parameter resets it.
export const IS_KYC_ENABLED = isFeatureTestMode('kyc');
